import { render, staticRenderFns } from "./Tasks.container.vue?vue&type=template&id=668086e2&scoped=true&"
import script from "./Tasks.container.vue?vue&type=script&lang=js&"
export * from "./Tasks.container.vue?vue&type=script&lang=js&"
import style0 from "./Tasks.container.vue?vue&type=style&index=0&id=668086e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668086e2",
  null
  
)

export default component.exports